import React, { useEffect, useRef } from "react";
import { useMediaQuery, useTheme } from "@mui/material";

const GlowingBackground = () => {
  const bubbleRefs = useRef([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    bubbleRefs.current.forEach((bubble, i) => {
      const direction = Math.random() > 0.5 ? "upDown" : "leftRight";
      const duration = 4 + Math.random() * 4; // 4s to 8s
      const delay = Math.random() * 2;

      bubble.style.animation = `${direction} ${duration}s ease-in-out ${delay}s infinite alternate`;
    });
  }, []);

  const bubbles = isMobile
    ? [
        { width: 80, height: 80, bg: "rgba(255,192,203,0.5)", top: "30%", left: "20%" },
        { width: 60, height: 60, bg: "rgba(186,85,211,0.45)", top: "80%", left: "-5%" },
        { width: 20, height: 20, bg: "rgba(100,149,237,0.9)", top: "20%", left: "28%" },
        { width: 15, height: 15, bg: "rgba(255,165,0,0.9)", top: "14%", left: "38%" },
        { width: 18, height: 18, bg: "rgba(255,105,180,0.9)", top: "18%", left: "46%" },
        { width: 30, height: 30, bg: "rgba(70,130,180,0.85)", top: "25%", left: "42%" },
        { width: 25, height: 25, bg: "rgba(255,182,193,0.9)", top: "65%", left: "50%" },
        { width: 8, height: 8, bg: "rgba(255,105,180,0.9)", top: "8%", left: "90%" },
        { width: 100, height: 100, bg: "rgba(255,105,180,0.25)", top: "50%", left: "10%" },
        { width: 120, height: 120, bg: "rgba(135,206,250,0.2)", top: "10%", left: "60%" },
      ]
    : [
        { width: 150, height: 150, bg: "rgba(255,192,203,0.5)", top: "30%", left: "20%" },
        { width: 130, height: 130, bg: "rgba(186,85,211,0.45)", top: "80%", left: "-5%" },
        { width: 30, height: 30, bg: "rgba(100,149,237,0.9)", top: "20%", left: "28%" },
        { width: 20, height: 20, bg: "rgba(255,165,0,0.9)", top: "14%", left: "38%" },
        { width: 25, height: 25, bg: "rgba(255,105,180,0.9)", top: "18%", left: "46%" },
        { width: 50, height: 50, bg: "rgba(70,130,180,0.85)", top: "25%", left: "42%" },
        { width: 35, height: 35, bg: "rgba(255,182,193,0.9)", top: "65%", left: "50%" },
        { width: 10, height: 10, bg: "rgba(255,105,180,0.9)", top: "8%", left: "97%" },
        { width: 200, height: 200, bg: "rgba(255,105,180,0.25)", top: "50%", left: "10%" },
        { width: 250, height: 250, bg: "rgba(135,206,250,0.2)", top: "10%", left: "60%" },
      ];

  return (
    <div
      style={{
        position: "relative",
        width: "99vw",
        height: "100%", // 🔁 Changed from 100vh to 100%
        background: "linear-gradient(to right, white, #c2e9fb)",
        overflow: "hidden",
      }}
    >
      <style>{`
        @keyframes upDown {
          0% { transform: translateY(0px); }
          100% { transform: translateY(-100px); }
        }
        @keyframes leftRight {
          0% { transform: translateX(0px); }
          100% { transform: translateX(100px); }
        }
      `}</style>

      {bubbles.map((b, i) => (
        <div
          key={i}
          ref={(el) => (bubbleRefs.current[i] = el)}
          style={{
            position: "absolute",
            width: b.width,
            height: b.height,
            top: b.top,
            left: b.left,
            background: `radial-gradient(circle, ${b.bg}, transparent)`,
            borderRadius: "50%",
            filter: "blur(8px)",
            opacity: 1,
          }}
        />
      ))}
    </div>
  );
};

export default GlowingBackground;
